export const serviciosWeb = [
  {
    id: "web-basica",

    nombre: "WEB BÁSICA",

    precio: "$250.000",

    descripcion:
      "Una presencia web profesional para comenzar.",

    color: "#555555",

    items: [
      "Diseño responsive",
      "Página de inicio",
      "Sección de servicios",
      "Formulario de contacto",
      "WhatsApp",
      "Dominio",
      "Publicación online",
    ],
  },

  {
    id: "web-profesional",

    nombre: "WEB PROFESIONAL",

    precio: "$450.000",

    descripcion:
      "Una web pensada para captar clientes.",

    color: "#891594",

    destacado: true,

    badge: "MÁS ELEGIDO",

    items: [
      "Todo lo incluido en WEB BÁSICA",
      "Diseño personalizado",
      "Formularios avanzados",
      "Firebase",
      "Base de datos",
      "Panel administrador",
      "Integración WhatsApp",
      "SEO básico",
    ],
  },

  {
    id: "web-avanzada",

    nombre: "WEB AVANZADA",

    precio: "$700.000+",

    descripcion:
      "Una solución web completa para empresas.",

    color: "#5D2470",

    items: [
      "Todo lo incluido en WEB PROFESIONAL",
      "Sistema de usuarios",
      "Panel administrativo",
      "Automatizaciones",
      "Integraciones externas",
      "Reportes",
      "Mantenimiento",
    ],
  },
];